import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';

//Helpers
import { objCampo } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from 'helpers/message';

//Api
import relatorio_api from '../../../api/relatorio_api';
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import RelatorioResumoMovimentoMensal from './RelatorioResumoMovimentoMensal';


function initialStateFiltros() {
    return {
        mesAno: "",
        modalidadeId: 0,
        modalidadeId_selected: { value: null, label: "Todos" },
        nomeRelatorio: "Relatórios - Resumo de Movimento Mensal"
    }
}

export default function ResumoMovimentoMensal() {
    //Estado que valida os possiveis erros nos campos de filtros
    const [errors, setErrors] = useState({});

    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true })
    ];

    const [selectedDate, setSelectedDate] = useState('');

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    //Estado que guarda os valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState([]);

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);


    const handleDateChange = (date) => {
        if (date && date.isValid()) {
            const month = date.format('MM');
            const year = date.format('YYYY');
            setFiltros({
                ...filtros,
                mesAno: `${month}/${year}`
            });
        }
        setSelectedDate(date);
    };

    //Change para os campos modalidade e transportadores
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        });
    }

    //Variavel de navegação na tela
    const navigate = useNavigate();

    const loadModalidades = () => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setOptionsModalidades([{ value: null, label: "Todos" }, ...response.data]);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadModalidades();
    }, []);

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {
        if (filtros.mesAno.length == 0) {
            showMessage("Aviso", "Por favor, selecione o Mês/Ano.", "warning", null);
            return;
        }

        setLoading(true);
        relatorio_api.ResumoMovimentoMensal(filtros)
            .then(response => {

                setDadosRelatorio(response.data);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (dadosRelatorio != null) {
        return <RelatorioResumoMovimentoMensal
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => {
                setDadosRelatorio(null)
                setSelectedDate('')
                setFiltros(initialStateFiltros())
            }}
            filtros={filtros} />
    }


    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Resumo de Movimento Mensal</h4>
            <Row sm="12" md="6" lg="4">
                <Col sm="12" md="6" lg="3">
                    <TextField
                        label={"*Mês/Ano"}
                        type="monthYear"
                        onChange={handleDateChange}
                        value={selectedDate}
                    />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField
                        placeholder='Selecione'
                        name="modalidadeId_selected"
                        label={"Modalidade"}
                        type={"select"}
                        searchable
                        value={filtros?.modalidadeId_selected}
                        invalid={!!errors.modalidadeId_selected}
                        onChange={onChangeSelected}
                        options={optionsModalidades}
                    />
                </Col>
                <Col sm="12" md="6" lg="3" style={{ marginTop: "1.875rem" }}>
                    <Button
                        className='w-100 fw-bold'
                        color='info text-light'
                        onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}

